import ImageCaptionPopover from './ImageCaptionPopover';

export default ImageCaptionPopover;
